export default __webpack_public_path__ + "static/media/DSC05871.491c6b05.jpg";